export const nextPageNumber = (linkHeader) => {
  return parseLinkHeader(linkHeader)?.next?.page;
};

// export const prevPageLink = linkHeader => {
//   return parseLinkHeader(linkHeader);
// };

export const lastPageNumber = (linkHeader) => {
  return parseLinkHeader(linkHeader)?.last?.page;
};

// Unquote string (utility)
const unquote = (value) => {
  if (value.charAt(0) === '"' && value.charAt(value.length - 1) === '"')
    return value.substring(1, value.length - 1);
  return value;
};

// Parse a Link header
const parseLinkHeader = (header) => {
  if (!header) {
    return null;
  }
  const linkexp = /<[^>]*>\s*(\s*;\s*[^()<>@,;:"/[\]?={} \t]+=(([^()<>@,;:"/[]?={} \t]+)|("[^"]*")))*(,|$)/g;
  const paramexp = /[^()<>@,;:"/[\]?={} \t]+=(([^()<>@,;:"/[\]?={} \t]+)|("[^"]*"))/g;

  const matches = header.match(linkexp);
  const rels = {};
  matches.forEach((match) => {
    const split = match.split(">");
    const href = split[0].substring(1);
    const params = new URLSearchParams(href.split("?")[1]);
    const page = parseInt(params.get("page"));

    const ps = split[1];
    const link = {};
    link.href = href;
    link.page = page;
    const s = ps.match(paramexp);
    for (const str of s) {
      const paramsplit = str.split("=");
      link[paramsplit[0]] = unquote(paramsplit[1]);
    }

    if (link.rel !== undefined) {
      rels[link.rel] = link;
    }
  });
  return rels;
};
